import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from "../../../axios-order";
import Grid from "@material-ui/core/Grid";
import classes from "./form16.module.css";
import { useHistory } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download';
import EmailIcon from '@mui/icons-material/Email';
import BoxWrapper from "../../../components/ui/boxWrapper";
import Form16 from './form16';
import ToggleSwitch from '../../../components/ui/ToggleSwitch/ToggleSwitch';
import RefreshIcon from '@mui/icons-material/Refresh';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CircularProgress from '@material-ui/core/CircularProgress';
import { IconButton, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  FormGroup,
  FormControlLabel
} from '@mui/material';
import { toast } from "react-toastify";

// Define refresh intervals: 0 (immediate), 1 minute, then every 15 minutes
const refreshIntervals = [0, 1, 15]; // Intervals in minutes

const getStatusButton = (status) => {
  switch (status) {
    case 'in_progress':
    case 'succeeded':
    case 'created':
      return (
        <Button
          variant="outlined"
          color="success"
          sx={{
            borderRadius: '8px',
            backgroundColor: '#e8f5e9',
            color: '#2e7d32',
            borderColor: '#81c784',
            textTransform: 'capitalize',
            '&:hover': {
              backgroundColor: '#c8e6c9',
              borderColor: '#66bb6a'
            }
          }}
        >
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </Button>
      );
    case 'failed':
    case 'queued':
    case 'polling_failed':
    case 'None':
      return (
        <Button
          variant="outlined"
          color="error"
          sx={{
            borderRadius: '8px',
            backgroundColor: '#ffebee',
            color: '#d32f2f',
            borderColor: '#ef9a9a',
            textTransform: 'capitalize',
            '&:hover': {
              backgroundColor: '#ffcdd2',
              borderColor: '#f44336'
            }
          }}
        >
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </Button>
      );
    default:
      return (
        <Button
          variant="outlined"
          sx={{
            borderRadius: '8px',
            backgroundColor: '#f5f5f5',
            color: '#616161',
            borderColor: '#e0e0e0',
            textTransform: 'capitalize',
            '&:hover': {
              backgroundColor: '#eeeeee',
              borderColor: '#bdbdbd'
            }
          }}
        >
          Unknown
        </Button>
      );
  }
};

const LogTables = () => {
  const history = useHistory();
  const [logData, setLogData] = useState([]);
  const [businessEntityId, setBusinessEntityId] = useState(localStorage.getItem("business_entity_id"));
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [isLogTableVisible, setIsLogTableVisible] = useState(true);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [showForm16, setShowForm16] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingJobs, setLoadingJobs] = useState({});
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState({});
  const [vendorEmails, setVendorEmails] = useState([]);
  const [panOfDeductee, setPanOfDeductee] = useState(null);
  const [firstCallTimes, setFirstCallTimes] = useState({});
  const [sequenceIndices, setSequenceIndices] = useState({});
  const [renderKey, setRenderKey] = useState(0);


  useEffect(() => {
    // Load initial log data
    getForm16Logs();
  }, []);

  const getForm16Logs = () => {
    axios
      .get(`/form_16_get_api/${businessEntityId}`)
      .then((res) => {
        const { status, message, data } = res.data;
        if (status === false) {
          toast.warn(message, { autoClose: 2000 });
        } else {
          setLogData(data);
        }
      })
      .catch((err) => console.error(err));
  };

  const handleBack = () => {
    history.push('/reportCards');
  };

  const toggleTableVisibility = () => {
    setIsTableVisible(!isTableVisible);
    setIsLogTableVisible(!isLogTableVisible);
  };

  const getTableLogVisibility = (job_id) => {
    const refreshTime = localStorage.getItem(`refreshTime_${job_id}`);
    history.push({
      pathname: `/Form16Details/${job_id}`,
      state: { refreshTime: refreshTime ? parseInt(refreshTime) : null }
    });
  };


  const onClickRefresh = (jobId) => {
    console.log(`Refreshing job with ID: ${jobId}`);

    // Set loading for only this specific job
    setLoadingJobs(prev => ({ ...prev, [jobId]: true }));

    const payload = {
      business_entity_id: businessEntityId,
      job_id: jobId
    }

    axios.post('/form_16_report_poll_job', payload)
      .then((res) => {
        console.log('API Response:', res?.data);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        // Clear loading for only this specific job
        setLoadingJobs(prev => ({ ...prev, [jobId]: false }));
        getForm16Logs();
      });
  };
  // const onClickRefresh = (jobId) => {
  //   const now = Date.now();
  //   // Default to now if lastCallTime is invalid
  //   const lastCallTime = Number(firstCallTimes[jobId]) || now;
  //   // Default to 0 if sequenceIndex is invalid
  //   const sequenceIndex = Number(sequenceIndices[jobId]) || 0;
  //   const elapsedMinutes = (now - lastCallTime) / (60 * 1000);

  //   // Find the job status from logData
  //   const job = logData.find(row => row.job_id === jobId);
  //   const jobStatus = job?.job_status || '';

  //   console.log(`Refresh clicked for job ${jobId}: status=${jobStatus}, elapsed=${elapsedMinutes.toFixed(2)} minutes, currentInterval=${refreshIntervals[sequenceIndex]}, sequenceIndex=${sequenceIndex}, lastCallTime=${new Date(lastCallTime).toLocaleString()}`);

  //   // Show CircularProgress for visual feedback
  //   setLoadingJobs(prev => ({ ...prev, [jobId]: true }));
  //   setTimeout(() => {
  //     setLoadingJobs(prev => ({ ...prev, [jobId]: false }));
  //   }, 3000); // Show spinner for 3 seconds

  //   // Use 15-minute interval for 'queued' status, otherwise use refreshIntervals
  //   const currentInterval = jobStatus === 'queued' ? 15 : refreshIntervals[sequenceIndex];
  //   // Move to next interval, but cap at the last index (15 minutes)
  //   const nextIntervalIndex = jobStatus === 'queued' ? 2 : Math.min(sequenceIndex + 1, refreshIntervals.length - 1);

  //   if (elapsedMinutes >= currentInterval || sequenceIndex === 0) {
  //     // Update local storage for this jobId
  //     localStorage.setItem(`refreshTime_${jobId}`, now.toString());
  //     localStorage.setItem(`firstCallTime_${jobId}`, now.toString());
  //     localStorage.setItem(`sequenceIndex_${jobId}`, nextIntervalIndex.toString());

  //     const payload = {
  //       business_entity_id: businessEntityId,
  //       job_id: jobId
  //     };

  //     console.log(`Calling API for job ${jobId} at ${new Date(now).toLocaleString()}`);

  //     axios.post('/form_16_report_poll_job', payload)
  //       .then((res) => {
  //         console.log('API Response:', res?.data);
  //         setFirstCallTimes(prev => ({ ...prev, [jobId]: now }));
  //         setSequenceIndices(prev => ({ ...prev, [jobId]: nextIntervalIndex }));
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         toast.error("Error refreshing job status", { autoClose: 2000 });
  //       })
  //       .finally(() => {
  //         getForm16Logs();
  //       });
  //   } else {
  //     // Ensure elapsedMinutes is a valid number, default to 0 if NaN
  //     const validElapsedMinutes = isNaN(elapsedMinutes) ? 0 : elapsedMinutes;
  //     const remainingMinutes = Math.ceil(currentInterval - validElapsedMinutes);
  //     console.log(`Job ${jobId} is locked out until interval ${currentInterval} minutes. Remaining: ${remainingMinutes} minutes`);
  //     //toast.info(`Please wait ${remainingMinutes} minute${remainingMinutes === 1 ? '' : 's'} until the next refresh.`, { autoClose: 3000 });
  //   }
  // };

  const handleErrorMessage = (errorMessage) => {
    toast.error(errorMessage, {
      autoClose: 3000,
      progress: 0,
    });
  };

  const onEnvelope = (pan_of_deductee) => {
    setIsEmailSent(true);
    setPanOfDeductee(pan_of_deductee);
    setVendorEmails([]);

    axios.get(`/form_16_get_api_email/${businessEntityId}/${pan_of_deductee}`)
      .then((res) => {
        if (res.data.status && res.data.data) {
          setVendorEmails(res.data.data);
          const initialSelectedState = {};
          res.data.data.forEach(item => {
            initialSelectedState[item.vendor_email] = false;
          });
          setSelectedEmails(initialSelectedState);
          setEmailDialogOpen(true);
        } else {
          setEmailDialogOpen(true);
        }
      })
      .catch((err) => {
        console.error(err);
        setEmailDialogOpen(true);
      });
  };

  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const pdfDownload = (id) => {
    const contentType = "application/pdf";
    const filename = `Form_16_${id}.pdf`;

    axios.get(`/form_16_get_api_download/${businessEntityId}/${id}`)
      .then((res) => {
        const base64Data = res?.data?.records;
        if (base64Data && base64Data[0]?.base64_pdf) {
          downloadBase64File(contentType, base64Data[0].base64_pdf, filename);
        } else {
          toast.error("No PDF data available for download", { autoClose: 2000 });
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error downloading PDF", { autoClose: 2000 });
      });
  };

  const handleFormSubmissionSuccess = () => {
    console.log("Form16 submission was successful, turning off toggle.");
    turnOffForm16Toggle(); // Prioritize turning off the toggle
    getForm16Logs(); // Then refresh the logs
  };

  const turnOffForm16Toggle = () => {
    console.log("Turning off Form16 toggle");
    setShowForm16(false);
    setRenderKey(prev => prev + 1); // Force a re-render
  };

  const handleToggleChange = (event) => {
    setShowForm16(event.target.checked);
  };

  const sendSelectedEmails = () => {
    const emailsToSend = Object.keys(selectedEmails).filter(email => selectedEmails[email]);
    if (emailsToSend.length > 0) {
      const payload = {
        business_entity_id: businessEntityId,
        pan_of_deductee: panOfDeductee,
        vendor_emails: emailsToSend,
      };

      axios.post('/form_16_report_email', payload)
        .then((res) => {
          if (res.data.status) {
            toast.success(res.data.message, { autoClose: 2000 });
          }
        })
        .catch((err) => {
          console.error('Error sending emails:', err);
          toast.error("Error sending emails", { autoClose: 2000 });
        })
        .finally(() => {
          setEmailDialogOpen(false);
        });
    } else {
      setEmailDialogOpen(false);
    }
  };

  const handleBackFn = () => {
    setIsTableVisible(false);
    setIsLogTableVisible(true);
    setShowForm16(false);
  };

  return (
    <div>
      <Grid item xs={12} style={{ display: "flex", alignItems: "center", gap: "16px" }} mb={8}>
        {isLogTableVisible && (
          <>
            <div>
              <ToggleSwitch
                key={renderKey}
                id="toggleUploadRecipient"
                onChange={handleToggleChange}
                checked={showForm16}
                label="Add New Form 16/16A"
              />
            </div>
              <Tooltip title="Back" arrow>
                                 <IconButton
                                     onClick={handleBack}
                                     sx={{
                                         borderRadius: '50%',
                                         padding: '6px',
                                         color: '#263238',
                                         fontSize: '20px',
                                         backgroundColor: '#ffffff',
                                         height: '36px',
                                         width: '36px',
                                         '&:hover': {
                                             backgroundColor: '#455a64',
                                             color: '#ffffff',
                                         },
                                         boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                         transition: 'background-color 0.3s ease',
                                     }}
                                 >
                                     <ArrowBackIcon sx={{ fontSize: '20px' }} />
                                 </IconButton>
                             </Tooltip>
          </>
        )}
      </Grid>
      {showForm16 && <div style={{ marginTop: "5px" }}><Form16 refresh={getForm16Logs} onFormSubmit={handleFormSubmissionSuccess} /></div>}

      {isLogTableVisible && (
        <BoxWrapper boxTitle="Form 16/16A">
          <TableContainer
            component={Paper}
            sx={{
              mb: 2,
              mt: 2,
              maxHeight: '51vh',
              overflow: 'auto',
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>FINANCIAL YEAR</TableCell>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>FORM</TableCell>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>FORM TYPE</TableCell>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>CREATED AT</TableCell>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>LAST UPDATED ON</TableCell>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>STATUS</TableCell>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>ACTION</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : logData.length > 0 ? (
                  logData.map((row, index) => (
                    <TableRow key={`table-row-${index}`}>
                      <TableCell style={{ fontFamily: "'Dosis'" }}>{row.financial_year}</TableCell>
                      <TableCell style={{ fontFamily: "'Dosis'" }}>{row.form}</TableCell>
                      <TableCell style={{ fontFamily: "'Dosis'" }}>{row.form_type}</TableCell>
                      <TableCell style={{ fontFamily: "'Dosis'" }}>{row.created_at}</TableCell>
                      <TableCell style={{ fontFamily: "'Dosis'" }}>{row.last_updated_on}</TableCell>
                      <TableCell style={{ fontFamily: "'Dosis'" }}>
                        {getStatusButton(row.job_status)}
                      </TableCell>
                      <TableCell>
                        {row.job_status === 'succeeded' ? (
                          <VisibilityIcon
                            color="primary"
                            onClick={() => getTableLogVisibility(row.job_id)}
                            style={{ cursor: 'pointer', marginLeft: '8px' }}
                          />
                        ) : row.job_status === 'failed' ? (
                          <VisibilityIcon
                            color="error"
                            onClick={() => handleErrorMessage(row.error_message)}
                          />
                        ) : (
                          <>
                            {loadingJobs[row.job_id] ? (
                              <CircularProgress
                                size={20}
                                style={{ color: "green", marginLeft: '5px', marginTop: '2px' }}
                              />
                            ) : (
                              <RefreshIcon
                                color="primary"
                                style={{ cursor: 'pointer' }}
                                onClick={() => onClickRefresh(row.job_id)}
                              />
                            )}
                            <VisibilityOffIcon
                              color="error"
                              style={{ cursor: 'not-allowed', pointerEvents: 'none', marginLeft: '8px' }}
                            />
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5}>No data available</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </BoxWrapper>
      )}

      {isTableVisible && (
        <BoxWrapper
          boxTitle="Form 16/16A"
          enableAddButton={true}
          addButtonLabel={'BACK'}
          addButtonHandlerFn={handleBackFn}
        >
          <TableContainer component={Paper} sx={{
            mb: 2, mt: 2, maxHeight: 'calc(100vh - 80px)',
            overflow: 'auto',
          }}>
            <Table>
              <TableHead stickyHeader>
                <TableRow>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>Employee/Vendor Name</TableCell>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>PAN</TableCell>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>Email ID</TableCell>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>Form Type</TableCell>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>Quarter</TableCell>
                  <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell colSpan={6}>No data available</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </BoxWrapper>
      )}

      <Dialog
        open={emailDialogOpen}
        onClose={() => setEmailDialogOpen(false)}
        aria-labelledby="email-dialog-title"
      >
        <DialogTitle id="email-dialog-title">Send Email</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Select recipients to send Form 16:
          </DialogContentText>
          {vendorEmails.length === 0 ? (
            <DialogContentText color="textSecondary">No email found</DialogContentText>
          ) : (
            <FormGroup>
              {vendorEmails.map((item, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={!!selectedEmails[item.vendor_email]}
                      onChange={(e) => {
                        setSelectedEmails({
                          ...selectedEmails,
                          [item.vendor_email]: e.target.checked
                        });
                      }}
                    />
                  }
                  label={item.vendor_email}
                />
              ))}
            </FormGroup>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEmailDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={sendSelectedEmails}
            color="primary"
            disabled={vendorEmails.length === 0}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default LogTables;